import { IonIcon, IonText } from "@ionic/react";
import { informationCircle, warningOutline } from "ionicons/icons";
import styled from "styled-components";

const NotificationWrap = styled.div`
  text-align: center;
`;

const MyChip = styled.div<{ $level?: "info" | "warning" | "danger" }>`
  background-color: ${(p) => {
    if (p.$level === "danger") return "var(--ion-color-danger-tint)";
    if (p.$level === "warning") return "var(--ion-color-warning-tint)";
    return "var(--ion-color-light-shade)";
  }};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  ${(p) => p.$level === "warning" && "color: #333;"}
  ${(p) => p.$level === "danger" && "color: #fff;"}
`;

const Text = styled(IonText)`
  margin-left: 10px;
  white-space: pre-line;
`;

interface Props {
  text?: React.ReactNode;
  content?: React.ReactNode;
  level?: "info" | "warning" | "danger";
}

const InfoMessage: React.FC<Props> = ({ text, content, level = "info" }) => {
  const iconName = level === "info" ? informationCircle : warningOutline;
  const iconColor = level === "danger" ? "light" : level === "warning" ? "danger" : "primary";

  return (
    <NotificationWrap>
      <MyChip $level={level}>
        {!content && (
          <>
            <IonIcon
              icon={iconName}
              color={iconColor}
              style={{ fontSize: 23, minWidth: 23, minHeight: 23 }}
            />
            {text && <Text>{text}</Text>}
          </>
        )}
        {content}
      </MyChip>
    </NotificationWrap>
  );
};

export default InfoMessage;
